import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import {
  AutocompleteInput,
  BooleanField,
  Button,
  Datagrid,
  DateField,
  FunctionField,
  List,
  ListActions,
  ReferenceField,
  ReferenceInput,
  SimpleList,
  TextField,
  TextInput,
} from "react-admin";
import { useNavigate } from "react-router";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { GraduationServicePath, MOBILE_BREAKPOINT, PLANS } from "utils/constants";
import EditIcon from "@mui/icons-material/Edit";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const ListInternshipPlans = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const filters = [
    <TextInput
      source="name"
      label="Име"
      alwaysOn
    />,
    <ReferenceInput
      label="Специалност"
      source="specialityId"
      reference={administrationRequests.getSpecialitiesSelect()}
      filter={{ filterByUser: true }}
      alwaysOn
    >
      <AutocompleteInput
        label="Специалност"
        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        style={{ width: 300 }}
      />
    </ReferenceInput>,
  ];
  return (
    <List
      exporter={false}
      title="Стажантски планове"
      filters={filters}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageInternshipPlans)} />}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={() => (
            <div>
              <MobileListRow fields={[{ label: "Име", value: <TextField source="name" /> }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Дата на входиране",
                    value: (
                      <DateField
                        source="entryDate"
                        locales="bg-BG"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specialityId"
                        reference={administrationRequests.getSpecialitiesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[{ label: "Общо хорариум часове", value: <TextField source="totalHorariumHours" /> }]}
              />
              <MobileListRow fields={[{ label: "Кредити", value: <TextField source="credits" /> }]} />
              <MobileListRow
                fields={[{ label: "Месечен стаж?", value: record?.isMonthlyInternship ? "Да" : "Не" }]}
              />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <SecuredComponent permission={permissions.canManageInternshipPlans}>
                  <Button
                    label="Редактирай"
                    startIcon={<EditIcon />}
                    onClick={() => navigate(`/${GraduationServicePath}update/${PLANS}/${record?.id}`)}
                  />
                </SecuredComponent>
              </div>
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={{
            "& .RaDatagrid-headerCell": {
              textAlign: "left",
            },
          }}
        >
          <TextField
            source="name"
            label="Име"
          />
          <DateField
            source="entryDate"
            label="Дата на входиране"
            locales="bg-BG"
          />
          <ReferenceField
            source="specialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
            label="Специалност"
          >
            <TextField source="name" />
          </ReferenceField>
          <TextField
            source="totalHorariumHours"
            label="Общо хорариум часове"
          />
          <TextField
            source="credits"
            label="Кредити"
          />
          <BooleanField
            source="isMonthlyInternship"
            label="Месечен стаж?"
          />
          <SecuredComponent permission={permissions.canManageInternshipPlans}>
            <FunctionField
              render={rec => (
                <Button
                  label="Редактирай"
                  startIcon={<EditIcon />}
                  onClick={() => navigate(`/${GraduationServicePath}update/${PLANS}/${rec?.id}`)}
                />
              )}
            />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListInternshipPlans;
